import { ClientAttachmentId } from 'owa-client-ids';
import { getDefaultRequestOptions } from 'owa-headers';
import DeleteAttachmentResponse from 'owa-service/lib/contract/DeleteAttachmentResponse';
import deleteAttachmentRequest from 'owa-service/lib/factory/deleteAttachmentRequest';
import deleteAttachmentOperation from 'owa-service/lib/operation/deleteAttachmentOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(attachmentId: ClientAttachmentId) {
    return deleteAttachmentRequest({
        ClientSupportsIrm: true,
        AttachmentIds: [attachmentId],
    });
}

export default async function deleteAttachment(
    attachmentId: ClientAttachmentId,
    requestOptions?: RequestOptions
): Promise<DeleteAttachmentResponse> {
    const requestBody = createRequestBody(attachmentId);

    // Adding the default request options and then merging it with the passed in request headers
    const defaultRequestOptions = (await getDefaultRequestOptions(attachmentId.mailboxInfo)) || {};
    const updatedRequestOptions = { ...defaultRequestOptions, ...(requestOptions || {}) };

    const response = await deleteAttachmentOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        updatedRequestOptions as RequestOptions
    );

    return response.Body;
}
